import type { ConfigSubTab } from '../hooks/useAttendanceSettings'
import { AttendanceSettingsForm } from './AttendanceSettingsForm'
import { ConfigurationSubTabs } from './ConfigurationSubTabs'
import { LeavePoliciesTab } from './LeavePoliciesTab'

interface ConfigurationTabProps {
  activeSubTab: ConfigSubTab
  onSubTabChange: (tab: ConfigSubTab) => void
  settingsState?: unknown
  onAddLeavePolicy: () => void
  onEditLeavePolicy: (id: string) => void
}

export function ConfigurationTab({
  activeSubTab,
  onSubTabChange,
  onAddLeavePolicy,
  onEditLeavePolicy,
}: ConfigurationTabProps) {
  return (
    <div className="space-y-6 min-w-0">
      {/* Row B: Segmented tab switcher on its OWN full-width row */}
      <ConfigurationSubTabs
        activeSubTab={activeSubTab}
        onSubTabChange={onSubTabChange}
      />

      {activeSubTab === 'attendance-settings' ? (
        <AttendanceSettingsForm />
      ) : (
        <LeavePoliciesTab
          onAddLeavePolicy={onAddLeavePolicy}
          onEditLeavePolicy={onEditLeavePolicy}
        />
      )}
    </div>
  )
}
